import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/InAppWidgetResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/pages/inappwidgets`;
	}
	listInAppWidgetsByProjectId(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/projectid`, { projectid: e }));
	}
};
export { n as InAppWidgetResource };

//# sourceMappingURL=InAppWidgetResource.js.map